import css from './PrivateRouteLayout.module.css';

import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { UserContext } from '../../context/userContext';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import StatusText from '../../components/Common/StatusText/StatusText';

type PrivateRouteLayoutProps = {
  requiredRole: string;
};

const PrivateRouteLayout = ({ requiredRole }: PrivateRouteLayoutProps) => {
  const { user, checkRole, checkUserType } = useContext(UserContext);
  const location = useLocation();

  if (user) {
    const reqRoles = requiredRole.split(',');

    const expired = checkRole!('Expired');
    const requireExpired = reqRoles.filter((rr) => rr === 'Expired').length > 0;
    const allowAny = requiredRole === 'Any';
    const hasUnexpired = reqRoles.filter((rr) => checkRole!(rr)).length > 0;

    const expiredPass = expired && requireExpired;
    const unexpiredPass = !expired && (allowAny || hasUnexpired);

    const hasRole = expiredPass || unexpiredPass;

    // Check if user is trying to access Document Store as a Lite user
    const isDocumentStore = location.pathname.toLowerCase() === '/documentstore';
    if (isDocumentStore && checkUserType!('lite')) {
      return (
        <FullScreen>
          <div className={css.accessDenied}>
            <StatusText
              text='You do not have permission to access the Document Store as a Lite user.'
              error={true}
            />
          </div>
        </FullScreen>
      );
    }

    if (hasRole) {
      return <Outlet />;
    }

    if (expired) {
      return <Navigate to={`/passwordExpired`} />;
    }

    return (
      <FullScreen>
        <div className={css.accessDenied}>
          <StatusText
            text='You do not have permission to view this page.'
            error={true}
          />
        </div>
      </FullScreen>
    );
  }

  return (
    <Navigate
      to={`/login?redirectTo=${encodeURIComponent(
        location.pathname + location.search + location.hash
      )}`}
    />
  );
};

export default PrivateRouteLayout;
